<template>
  <b-row>
    <b-col cols="12" md="4" offset-md="4">
      <b-card v-if="!error && !processed">
        <b-card-title>Reject the following user to make them inactive in your company</b-card-title>
        <p>Name: <strong>{{ user.name }}</strong></p>
        <p>Email address: <strong>{{ user.email }}</strong></p>
        <p><b-button variant="danger" @click.prevent="makeUserInactive()">Reject User</b-button></p>
        <p><b-button :to="{ name: 'companyoverview' }">Go to company admin dashboard</b-button></p>
      </b-card>
      <b-card v-else-if="!error && processed">
        <p><strong>{{ user.name }}</strong> is now inactive in your company</p>
        <p><b-button :to="{ name: 'companyoverview' }">Go to company admin dashboard</b-button></p>
      </b-card>
      <b-card v-else-if="error">
        An unexpected error occured, please try again
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ApproveNewSuffix',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BButton,
  },
  props: {
    userLoginId: {
      type: [String],
      default: 'empty',
    },
  },
  data() {
    return {
      user: {
        name: '',
        email: '',
      },
      hasAccess: false,
      error: false,
      processed: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isCompanyAdmin',
    ]),
  },
  async created() {
    this.hasAccess = this.isCompanyAdmin
    if (this.hasAccess) {
      await this.getUsersDetails()
    } else {
      this.$router.push({ name: 'home' })
    }
  },
  methods: {
    makeUserInactive() {
      this.$http.get('companymanagment.cfc?method=deactivateUser', {
        params: { usersLoginId: this.userLoginId },
      })
        .then(response => {
          if (response.data.status) {
            this.processed = true
          } else {
            this.error = true
          }
        })
        .catch(() => {
          this.error = true
        })
    },
    async getUsersDetails() {
      return this.$http.get('companymanagment.cfc?method=getUsersDetails', {
        params: { usersLoginId: this.userLoginId },
      })
        .then(response => {
          if (response.data.status) {
            this.user = response.data.user
          } else {
            this.error = true
          }
        })
        .catch(() => {
          this.error = true
        })
    },
  },
}
</script>
